import { toast } from 'sonner';

// Flag pour supprimer les toasts pendant la transition de logout (évite "permission denied" / sons sur la page login)
let suppressToasts = false;
export const setSuppressToasts = (value) => {
  suppressToasts = !!value;
};

// Wrapper pour sonner qui expose une API compatible avec Ant Design message
// Supporte maintenant les options avancées de Sonner (description, action, etc.)
const messageApi = {
  success: (content, duration = 3, options = {}) => {
    if (suppressToasts) return;
    if (typeof content === 'string') {
      toast.success(content, { 
        duration: duration * 1000,
        ...options 
      });
    } else {
      // Si content est un objet avec title, description, etc.
      toast.success(content.title || content, {
        description: content.description,
        action: content.action,
        duration: duration * 1000,
        ...options
      });
    }
  },
  error: (content, duration = 3, options = {}) => {
    if (suppressToasts) return;
    if (typeof content === 'string') {
      toast.error(content, { 
        duration: duration * 1000,
        ...options 
      });
    } else {
      toast.error(content.title || content, {
        description: content.description,
        action: content.action,
        duration: duration * 1000,
        ...options
      });
    }
  },
  warning: (content, duration = 3, options = {}) => {
    if (suppressToasts) return;
    if (typeof content === 'string') {
      toast.warning(content, { 
        duration: duration * 1000,
        ...options 
      });
    } else {
      toast.warning(content.title || content, {
        description: content.description,
        action: content.action,
        duration: duration * 1000,
        ...options
      });
    }
  },
  info: (content, duration = 3, options = {}) => {
    if (suppressToasts) return;
    if (typeof content === 'string') {
      toast.info(content, { 
        duration: duration * 1000,
        ...options 
      });
    } else {
      toast.info(content.title || content, {
        description: content.description,
        action: content.action,
        duration: duration * 1000,
        ...options
      });
    }
  },
  loading: (content) => {
    return toast.loading(content);
  },
};

export const setMessageApi = (_api) => {
  // Gardé pour compatibilité mais n'est plus utilisé
  // Les composants utilisent maintenant directement sonner
};

export const getMessageApi = () => messageApi;
